// Menú de escritorio: abre los desplegables / megamenú al pasar el ratón (Dawn solo los abre con clic)
(function () {
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

  function setOpen(details, open) {
    var summary = details.querySelector('summary');
    if (open) details.setAttribute('open', '');
    else details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function init() {
    var items = document.querySelectorAll('.header__inline-menu details');
    items.forEach(function (details) {
      var zone = details.closest('li') || details;
      var timer = null;
      zone.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (other) {
          if (other !== details) setOpen(other, false);
        });
        setOpen(details, true);
      });
      // pequeño margen para poder bajar el ratón hasta el panel sin que se cierre
      zone.addEventListener('mouseleave', function () {
        timer = setTimeout(function () { setOpen(details, false); }, 200);
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
